<div class="timer-element">
    <app-timer
        [time]="element.context.time"
        [autostart]="element.context.autostart"
        [value]="value"
        (valueChanged)="onChange($event)"
    ></app-timer>
</div>
